import React from 'react';
import './PreviousConferences.css';

const PreviousConferences = () => {
  const conferences = [
    {
      id: 1,
      title: 'WIEMTI-Ghana 2018',
      location: ' Accra, Ghana',
      year: '2018',
      image: '/images/wiemti-bg1.png',
      link: '/THE-REPORT-OF-WAIEMTI-2018-SUMMIT-GHANA-DRAFT.pdf',
      external: true
    },
    {
      id: 2,
      title: 'WIEMTI-Ghana 2018',
      location: ' Accra, Ghana',
      year: '2018',
      image: '/images/wiemti-bg2.png',
      link: '/ABVIG-2018-WAIEMTI-SUMMIT-REPORT.pdf',
      external: true
    },
    // {
    //   id: 3,
    //   title: 'AICIS Ghana 2018',
    //   location: 'Ghana',
    //   year: '2018',
    //   image: '/images/ghana.jpg',
    //   link: '/aicis-ghana-2018-details'
    // },
    {
      id: 4,
      title: 'WAIEMTI 2019',
      location: ' Accra, Ghana',
      year: '2019',
      image: '/images/ghana.jpg',
      link: '/WAIEMTI-2019-EDITION-REPORT.pdf'
    
    },
    {
      id: 9,
      title: 'National Symposium on Niger Delta Infrastructure Development and Promotion of Non-Oil Sector Summit',
      location: 'Nigeria',
      year: '2021',
      image: '/images/abia-state-bg.png',
      link: '/REPORT-OF-INSPECTION-ABIA-INTERNATIONAL-CONFERENCE-CENTER.pdf'
    },
    {
      id: 6,
      title: 'Launch of AIEMTIS - Africa Infrastructure, Energy, Mining, Trade Exhibition, and Investment Summit  2021 ',
      location: 'Abuja, Nigeria',
      year: '2021',
      image: '/images/aiemtis-bf.png',
      link: '/LAUNCH-OF-AIEMTI-2021.pdf'
    },
    {
      id: 5,
      title: 'African Infrastructure, Climate Change, and Investment Summit (AICIS) Washington D.C.',
      location: 'Washington D.C., USA',
      year: '2023/2024',
      image: '/images/washington-dc.jpg',
      link: 'https://abviggh.wixsite.com/abvig/aicis-washington-dc'
    },

    {
      id: 7,
      title: 'International Symposium on Africa Infrastructure, Climate Change and Investment',
      location: 'Abuja, Nigeria',
      year: '2024',
      image: '/images/symposm-bg.png',
      link: '/SYMPOSIUM-REPORT-2024.pdf'
    },
    // {
    //   id: 8,
    //   title: 'Diplomatic Engagement 2025',
    //   location: 'MFA Nigeria',
    //   year: '2025',
    //   image: '/images/aicis-activities-01.jpeg',
    //   link: '/diplomatic-engagement-details'
    // },
    {
      id: 11,
      title: 'African Infrastructure, Climate Change, and Investment Summit (AICIS) 2025 Summit',
      location: 'Abuja, Nigeria',
      year: '2025',
      image: '/images/2025-1.jpeg',
      link: 'https://aicisnigeria.abvig.org/'
    },
    {
      id: 10,
      title: 'Post-Summit Stakeholder Engagement',
      location: 'Abuja, Nigeria',
      year: '2025',
      image: '/images/2025-2.jpg',
      link: 'https://aicisnigeria.abvig.org/aicis-2025-post-summit-workshop/'
    }
  
  ];

  return (
    <div>
      <section className="page-hero">
        <h1>Previous Conferences & Summits</h1>
        <p>Past AICIS conference and summit events</p>
      </section>

      <section className="page-content">
        <div className="container">
          <div className="summit-list">
            {conferences.map((conference) => (
              <a 
                href={conference.link} 
                target={conference.external || conference.link.startsWith('http') ? '_blank' : '_self'} 
                rel="noopener noreferrer" 
                className="summit-card-link"
                key={conference.id}
              >
                <div className="summit-card">
                  <div 
                    className="summit-image" 
                    style={{
                      backgroundImage: `url(${conference.image})`,
                      backgroundPosition: '50% 20%',
                      backgroundSize: 'cover',
                      backgroundRepeat: 'no-repeat'
                    }}
                  ></div>
                  <div className="summit-info">
                    <h3>{conference.title}</h3>
                    <p><strong>Location:</strong> {conference.location}</p>
                    <p><strong>Year:</strong> {conference.year}</p>
                    <span className="summit-link-text">
                      {conference.external ? 'View Full Report →' : 
                       conference.link.startsWith('http') ? 'View Summit →' : 'View Details →'}
                    </span>
                  </div>
                </div>
              </a>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default PreviousConferences;